import { render, staticRenderFns } from "./CreateNewOrder.vue?vue&type=template&id=8d1baa9c&scoped=true&"
import script from "./CreateNewOrder.vue?vue&type=script&lang=js&"
export * from "./CreateNewOrder.vue?vue&type=script&lang=js&"
import style0 from "./CreateNewOrder.vue?vue&type=style&index=0&id=8d1baa9c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d1baa9c",
  null
  
)

export default component.exports